import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  titles: [],
};

export const titleSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setTitle: (state, action) => {
      const p = action.payload;
      if (
        p &&
        typeof p === "object" &&
        !Array.isArray(p) &&
        Array.isArray(p.list)
      ) {
        state.titles = p.list;
      } else {
        state.titles = Array.isArray(p) ? p : [];
      }
    },
  },
});

const titleReducer = titleSlice.reducer;

export const { setTitle } = titleSlice.actions;

export default titleReducer;
